[
 {
  "id": "adult",
  "x": 656,
  "y": 546,
  "w": 172,
  "h": 92
 },
 {
  "id": "consent",
  "x": 656,
  "y": 1090,
  "w": 172,
  "h": 92
 },
 {
  "id": "woman",
  "x": 100,
  "y": 738,
  "w": 257,
  "h": 92
 },
 {
  "id": "man",
  "x": 351,
  "y": 738,
  "w": 240,
  "h": 92
 },
 {
  "id": "nb",
  "x": 586,
  "y": 738,
  "w": 256,
  "h": 92
 },
 {
  "id": "b1",
  "x": 98,
  "y": 942,
  "w": 190,
  "h": 93
 },
 {
  "id": "b2",
  "x": 283,
  "y": 942,
  "w": 190,
  "h": 93
 },
 {
  "id": "b3",
  "x": 469,
  "y": 942,
  "w": 190,
  "h": 93
 },
 {
  "id": "b4",
  "x": 655,
  "y": 942,
  "w": 189,
  "h": 93
 },
 {
  "id": "continue",
  "x": 145,
  "y": 1205,
  "w": 651,
  "h": 111
 }
]